/**
 * Copyright (c) 2020 PayGate (Pty) Ltd
 *
 * Author: App Inlet (Pty) Ltd
 *
 * Released under the GNU General Public License Version 3
 *
 */

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   apiURL: 'http://localhost:4000/api',
//   soapApiURL: 'http://localhost:4000'
// };


export const environment = {
  production: false,
  apiURL: 'https://young-peak-07315.herokuapp.com/api',
  soapApiURL: 'https://young-peak-07315.herokuapp.com'
};

// export const environment = {
//     production: true,
//     apiURL: 'https://ecb7e62c0084.ngrok.io/api',
//     soapApiURL: 'https://ecb7e62c0084.ngrok.io'
// };


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
